/**
 * @genesis_domain Auth Engine / Shared Schema
 * @genesis_version V10.0
 * @genesis_intent Recovery-specific Zod schemas — separated from the three-field Settings schema per architectural boundary
 * @genesis_boundaries FORBIDDEN from importing Settings schemas; FORBIDDEN from defining fields outside password recovery scope
 * @genesis_ai_trail V10.0: Created for forced password recovery routing intercept — keeps recovery schema isolated from profile/settings forms.
 */

import { z } from 'zod';

/**
 * Two-field schema for forced password recovery.
 * Requires newPassword + confirmNewPassword with matching refinement.
 * Distinct from the three-field Settings/profile password form.
 */
export const RecoveryPasswordSchema = z
    .object({
        newPassword: z.string().min(6, 'Password must be at least 6 characters'),
        confirmNewPassword: z.string().min(6, 'Please confirm your new password'),
    })
    .refine(data => data.newPassword === data.confirmNewPassword, {
        message: 'Passwords do not match',
        path: ['confirmNewPassword'],
    });

export type RecoveryPasswordFormData = z.infer<typeof RecoveryPasswordSchema>;